<script setup lang="ts">
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useSleep } from '~/composables/useSleep';
import type { IgMediaItem } from '~~/src/core/types';
import { assert } from '~~/src/layers/toolkit/toolkit';

defineProps<{
  posts: IgMediaItem[];
}>();

const container = useTemplateRef('container_ref');
let ctx: gsap.Context | undefined;

onMounted(async () => {
  await nextTick();
  assert(container.value, 'Container is mounted');

  ctx = gsap.context(() => {
    const cards = gsap.utils.toArray<HTMLElement>('.feed-card');
    const endTrigger = cards[cards.length - 1];

    const BASE_TOP = 96;
    const STACK_GAP = 24;

    const cardLastPinTop = BASE_TOP + (cards.length - 1) * STACK_GAP;

    cards.forEach((card, index) => {
      const pinTop = BASE_TOP + index * STACK_GAP;

      ScrollTrigger.create({
        trigger: card,
        start: `top ${pinTop}px`,
        endTrigger,
        end: `top ${cardLastPinTop}px`,
        pin: true,
        pinSpacing: false,
        anticipatePin: 1,
      });
    });
  }, container.value);

  // Just in case onNuxtReady triggers refresh earlier than page layout settles.
  await useSleep(2000);
  ScrollTrigger.refresh();
});

onNuxtReady(() => {
  ScrollTrigger.refresh();
});

onUnmounted(() => {
  ctx?.revert();
});
</script>

<template>
  <div ref="container_ref" class="gap-r4 relative flex flex-col">
    <FeedPostMobile
      v-for="post in posts"
      :key="post.id"
      :post="post"
      class="feed-card"
    />
  </div>
</template>
